import axios from 'axios';
import { API_BASE_URL } from '../api';

export async function getPublicVendors({ page = 1, limit = 24, search = '' } = {}) {
  const params = { page, limit };
  if (search && String(search).trim()) params.search = String(search).trim();
  const res = await axios.get(`${API_BASE_URL}/users/public/vendors`, {
    params,
    timeout: 30000,
  });
  return res.data?.data || { vendors: [], pagination: {} };
}
